import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

import getValidColor from '../../lib/get-valid-color';
import {
  backgroundColorPicker,
  stringInputSpec,
} from '../../lib/editing-configs';

const customBackgroundPicker = {
  ...backgroundColorPicker,
  fieldName: 'bgOptions.backgroundColor',
  items: backgroundColorPicker.items.concat({
    value: 'HEXCOLOR',
    label: 'Hexcolor',
  }),
};

const BackgroundColor = ({ bgOptions, children }) => {
  const { backgroundColor, hexColor } = bgOptions;
  const hasHexcolorDropdown = backgroundColor === 'HEXCOLOR';
  const hasBgHexcolor = hexColor !== '';
  const color =
    hasHexcolorDropdown && hasBgHexcolor
      ? hexColor
      : getValidColor(backgroundColor);

  return children(color);
};

BackgroundColor.propTypes = {
  bgOptions: PropTypes.shape({
    backgroundColor: PropTypes.string,
    hexColor: PropTypes.string,
  }),
  children: PropTypes.func.isRequired,
};

BackgroundColor.getEditingConfig = (componentDocument) => {
  const optionalSelect =
    get(componentDocument, 'props.bgOptions.backgroundColor', '') === 'HEXCOLOR'
      ? [stringInputSpec('bgOptions.hexColor', 'Background hex color override')]
      : [];
  return [customBackgroundPicker, ...optionalSelect];
};

BackgroundColor.defaultProps = {
  bgOptions: {
    hexColor: '',
  },
};

export default BackgroundColor;
